export default __webpack_public_path__ + "static/media/recruit_section_image_2@2x.cd9f0fc0.webp";